import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { Center, CenterType } from 'src/app/_models/center.model';
import { Country } from 'src/app/_models/country.mode';
import { LatestOffer } from 'src/app/_models/latestOffers.model';
import { MobileRoutes } from 'src/app/_models/routes.model';
import { CentersService } from 'src/app/_services/centers.service';
import { CountriesService } from 'src/app/_services/countries.service';
import { LatestOffersService } from 'src/app/_services/latest-offers.service';
import { RoutesService } from 'src/app/_services/routes.service';
import { baseUrl, environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-center',
  templateUrl: './add-center.component.html',
  styleUrls: ['./add-center.component.scss'],
})
export class AddCenterComponent implements OnInit {
  pageTitle: string = 'Labs';
  labTypes: CenterType[];
  countries: Country[];
  imageFile;
  editMode = false;
  lab: Center = {
    name: '',
    arName: '',
    phone: '',
    email: '',
    isActive: true,
    countryId: 0,
    centerTypeId: 0,
  };
  addLabForm: FormGroup;
  isSubmited: boolean = false;
  labFileName: string = '';

  constructor(
    private centerService: CentersService,
    private countryService: CountriesService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.addLabForm = this._formBuilder.group({
      enLabName: [
        null,
        [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)],
      ],
      arLabName: [
        null,
        [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)],
      ],
      labPhone: [null, [Validators.required]],
      labEmail: [null, [Validators.required]],
      labType: [null, [Validators.required]],
      labCountry: [null, [Validators.required]],
      labFileInput: [null, [Validators.required]],
      labActiveCheck: [true, [Validators.required]],
    });

    this.countries = this.countryService.getAllCountries();
    this.getAllLabTypes();

    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.centerId;
      this.getLabById(id);
    }
  }

  getAllLabTypes() {
    this.centerService.getAllCenterTypes().subscribe((res) => {
      this.labTypes = res.data.centerTypes;
    });
  }

  getLabById(labId) {
    this.centerService.getCenterById(labId).subscribe((res) => {
      this.lab = res.data;

      document.getElementById(
        'placeholder'
      ).style.backgroundImage = `url(${res.data['logo']})`;

      this.labFileName = this.lab.logo.split('/').pop();

      this.addLabForm.patchValue({
        enLabName: this.lab.name,
        arLabName: this.lab.arName,
        labPhone: this.lab.phone,
        labEmail: this.lab.email,
        labType: this.lab.centerTypeId,
        labCountry: this.lab.countryId,
        labFileInput: this.labFileName,
        labActiveCheck: this.lab.isActive,
      });
    });
  }

  buildLabObject(data) {
    this.lab.name = data.enLabName;
    this.lab.arName = data.arLabName;
    this.lab.phone = data.labPhone;
    this.lab.email = data.labEmail;
    this.lab.centerTypeId = data.labType;
    this.lab.countryId = data.labCountry;
    this.lab.isActive = data.labActiveCheck;
  }

  onAddLabSubmit() {
    this.isSubmited = true;

    this.buildLabObject(this.addLabForm.value);

    if (this.addLabForm.valid) {
      if (this.editMode) {
        this.centerService
          .updateCenter(this.imageFile, this.lab)
          .subscribe((res) => {
            showNotification(
              'success',
              `${res.data.name} has been updated`,
              this.toastr
            );
            this.router.navigateByUrl('centers');
          });
      } else {
        this.centerService
          .addCenter(this.imageFile, this.lab)
          .subscribe((res) => {
            showNotification(
              'success',
              `${res.data.name} has been added`,
              this.toastr
            );
            this.router.navigateByUrl('centers');
          });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }

  onImageUpload(imageFile): void {
    this.imageFile = imageFile.target.files[0];
    this.labFileName = this.imageFile.name;
    this.addLabForm.controls['labFileInput'].setValue(
      imageFile ? this.labFileName : ''
    );

    let reader = new FileReader();
    let imageUrl;

    reader.readAsDataURL(this.imageFile);

    reader.onload = (event) => {
      imageUrl = event.target.result;
      document.getElementById('placeholder').style.backgroundImage = `url(${imageUrl})`;
    };
  }
}
